import React from 'react';
import { LogOut } from 'lucide-react';
import { signOut } from '../lib/auth';

export function LogoutButton() {
  const handleLogout = async () => {
    try {
      await signOut();
      // Force page reload to clear state
      window.location.reload();
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <button
      onClick={handleLogout}
      className="inline-flex items-center gap-2 p-2 text-gray-600 hover:text-red-600 transition-colors rounded-lg"
      title="Sair"
    >
      <LogOut size={20} />
      <span className="hidden sm:inline">Sair</span>
    </button>
  );
}